import React from 'react';
//Material UI Components
import {IconButton, Tooltip} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    button: {
        padding: '.5rem',
        paddingLeft: 4,
    }
}));

const ToolbarButton = ({title, onClick, Icon, disabled}) => {
    const classes = useStyles();
    return <Tooltip title={title}>
        <span>
            <IconButton className={classes.button} disabled={disabled} onClick={onClick}>
            <Icon/>
        </IconButton>
        </span>
    </Tooltip>
};

export default ToolbarButton;
